import React, { FC, useState, MouseEvent, useEffect, useContext } from "react";
import GridEventProvider from "components/context/GridEventContext";
import { GridApi, GridReadyEvent } from "ag-grid-community";
import { handleAgGridFilterIcon, trackButton } from "utils";
import ClearFilter from "components/portfolio/GridViewFunction/ClearFilter";
import SaveSearch from "components/portfolio/GridViewFunction/SaveSearch";
import ActiveFilter from "components/common/ActiveFilter";

type FeatureType =
  "" | "tag" | "download" | "saveSearch" | "favorite" | "activeFilter" | "coverageStatus";

export interface GirdViewFunction {
  anchorEl: HTMLButtonElement | null;
  open: boolean;
  onClose: () => void;
  onClick: (e: any) => void;
  ready: boolean;
  pageId?: string;
  gridEvent?: GridReadyEvent;
  selectedRows?: number;
  factorMappings?: { [key: string]: string };
  workloadMappings?: { [key: string]: string };
}

const GridViewFunctionBar: FC = ({}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [featureType, setFeatureType] = useState<FeatureType>("");
  const { gridEvent } = useContext(GridEventProvider);
  const [ready, setReady] = useState(false);
  const [filterList, setFilterList] = useState<string[]>([]);
  const [_selectedRows, setSelectedRows] = useState(0);

  // const { data: eventMappings } = useMetadataByCategory("RENEWAL_FACTORS");
  // const { data: workloadCategory } = useMetadataByCategory("WORKLOAD");

  // const factorMappings: { [key: string]: string } = (
  //   eventMappings ?? []
  // ).reduce((obj, item) => {
  //   obj[item.code] = item.value;
  //   return obj;
  // }, {} as { [key: string]: string });

  // const workloadMappings: { [key: string]: string } = (
  //   workloadCategory ?? []
  // ).reduce((obj, item) => {
  //   obj[item.code] = item.value;
  //   return obj;
  // }, {} as { [key: string]: string });

  const initActiveFilter = () => {
    const filterModel = gridEvent?.api.getFilterModel();
    if (!!filterModel) {
      const { _externalFilter, _externalSearch, ...extra } = filterModel;
      if (!!extra) {
        setFilterList(Object.keys(extra));
      }
    }
  };

  useEffect(() => {
    addEventListener("COLUMN_INITIALED", (e: any) => {
      setReady(true);
      const api: GridApi = e.detail.api;
      handleAgGridFilterIcon(api);
    });
    initActiveFilter();
    gridEvent?.api?.addEventListener("filterChanged", () => {
      initActiveFilter();
    });
    gridEvent?.api?.addEventListener("rowSelected", () => {
      const selectedRows = gridEvent.api.getSelectedRows();
      setSelectedRows(selectedRows.length ?? 0);
    });
  }, [gridEvent]);

  const handleClick = (type: FeatureType) => (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl((old) => (old === event.currentTarget ? null : event.currentTarget));
    setFeatureType(type);
    if (type === "download") {
      trackButton(type);
    }
  };
  const onClose = () => {
    setAnchorEl(null);
    setFeatureType("");
  };

  // control select box
  useEffect(() => {
    if (gridEvent) {
      if (
        (featureType === "download" ||
          featureType === "tag" ||
          featureType === "favorite" ||
          featureType === "coverageStatus") &&
        !!anchorEl
      ) {
        // gridEvent.columnApi.setColumnVisible("externalCheckbox", true);
      } else {
        gridEvent.api.deselectAll();
        // gridEvent.columnApi.setColumnVisible("externalCheckbox", false);
      }
    }
  }, [gridEvent, featureType, anchorEl]);
  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <ClearFilter ready={ready} />
        <SaveSearch
          open={featureType === "saveSearch" && !!anchorEl}
          anchorEl={anchorEl}
          onClose={onClose}
          onClick={handleClick("saveSearch")}
          ready={ready}
          pageId="portfolio"
          gridEvent={gridEvent}
        />
      </div>
      {filterList?.length ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            // marginLeft: "120px",
          }}
        >
          <ActiveFilter
            gridEvent={gridEvent}
            ignoreColumns={[
              "externalFilter",
              "externalSearch",
              "externalAlertFilter",
              "externalKeyword",
              "externalQuery",
            ]}
          />
        </div>
      ) : null}
    </>
  );
};

export default GridViewFunctionBar;
